"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var AskDataIcon = function (props) { return (
// tslint:disable:max-line-length
React.createElement("svg", __assign({ width: 18, height: 18, viewBox: '0 0 18 18' }, props),
    React.createElement("path", { fill: '#666', fillRule: 'evenodd', d: 'M16,1 C16.5522847,1 17,1.44771525 17,2 L17,12 C17,12.5522847 16.5522847,13 16,13 L9.444,13 L5,18 L5,13 L1,13 C0.44771525,13 0,12.5522847 0,12 L0,2 C0,1.44771525 0.44771525,1 1,1 L16,1 Z M16,2 L1,2 L1,12 L6,12 L6,15.368 L8.9949041,12 L16,12 L16,2 Z M12,6 L12,10 L11,10 L11,6 L12,6 Z M9,4 L9,10 L8,10 L8,4 L9,4 Z M6,7 L6,10 L5,10 L5,7 L6,7 Z' }))
// tslint:enable:max-line-length
); };
exports.AskDataIcon = AskDataIcon;
//# sourceMappingURL=AskDataIcon.js.map